import { AutoComplete, Form, Input } from 'antd';

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [C5c §4] A DUTY POINT'S SECTOR — `ZoneField`'s twin, placed right after it, and UNBOUNDED.
 *
 *  Everything `ZoneField`'s header records holds here unchanged: the suggestions are the OTHER cards'
 *  sectors and nothing else (`sectorOptionsFor`); the value is bound through `Form.Item`, never
 *  `setFieldValue`, so typing arms autosave by itself; the `aria-label` is on the child `Input`; and
 *  it is gated on `readOnly` alone, because the server freezes no sector on a live order.
 *
 *  ⚠️ THE ONE DIFFERENCE IS THE POINT: NO `maxLength`. The client asked for no length limit, and an
 *  input `maxlength` would clip a paste silently — the operator would see their text end and nothing
 *  would say why. `Feedback.test.tsx` asserts the attribute is absent, with the zone's as its control.
 *
 *  ⚠️ A TWIN RATHER THAN A GENERALISED `ZoneField`, so no existing test id, import or prop moves.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
export const SectorField = ({
  index,
  options,
  disabled,
  label,
  placeholder,
}: {
  index: number;
  options: readonly string[];
  disabled: boolean;
  label: string;
  placeholder: string;
}) => (
  <Form.Item name={['dutyPoints', index, 'sector']} label={label} className="mb-0 min-w-48 max-w-xs">
    <AutoComplete
      options={options.map((sector) => ({ value: sector }))}
      filterOption={(input, option) =>
        String(option?.value ?? '')
          .toLowerCase()
          .includes(input.trim().toLowerCase())
      }
      disabled={disabled}
      data-testid={`duty-point-sector-${String(index)}`}
    >
      <Input aria-label={label} placeholder={placeholder} allowClear />
    </AutoComplete>
  </Form.Item>
);
